import React from 'react'
const TabNavItem = ({id,title,icon,iconfill,activeTab,setActiveTab}) => {
    const handleClick = () => {
        setActiveTab(id);
    }
    return ( 
        <li onClick={handleClick} className={activeTab === id ? "nav-link active":"nav-link"} style={{"cursor":'pointer'}}>
        <span> <i className={activeTab === id ? iconfill:icon}></i>
         <small> {title}</small></span>
    </li>
     );
}
 
export default TabNavItem;